import api from './api';
import { ODC } from '../types';

interface ODCListResponse {
  success: boolean;
  data: {
    odcs: ODC[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  };
}

interface ODCResponse {
  success: boolean;
  data: ODC;
  message?: string;
}

interface ODCStatsResponse {
  success: boolean;
  data: {
    total: number;
    active: number;
    inactive: number;
    bySpop: number;
    averageRadius: number;
  };
}

interface CreateODCData {
  spopId: string;
  odcCode: string;
  address: string;
  radius: number;
  latitude: number;
  longitude: number;
  description?: string;
}

interface UpdateODCData extends CreateODCData {
  isActive: boolean;
}

const odcService = {
  // Get all ODCs with pagination and filters
  async getODCs(params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
    spopId?: string;
  }): Promise<ODCListResponse> {
    const response = await api.get('/odcs', { params });
    return response.data;
  },

  // Get ODC by ID
  async getODCById(id: string): Promise<ODCResponse> {
    const response = await api.get(`/odcs/${id}`);
    return response.data;
  },

  // Create new ODC
  async createODC(data: CreateODCData): Promise<ODCResponse> {
    const response = await api.post('/odcs', data);
    return response.data;
  },

  // Update ODC
  async updateODC(id: string, data: Partial<UpdateODCData>): Promise<ODCResponse> {
    const response = await api.put(`/odcs/${id}`, data);
    return response.data;
  },

  // Delete ODC
  async deleteODC(id: string): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/odcs/${id}`);
    return response.data;
  },

  // Get ODC statistics
  async getODCStats(filters?: { spop_id?: string; [key: string]: any }): Promise<ODCStatsResponse> {
    const params = new URLSearchParams();
    
    // Add filters
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const response = await api.get(`/odcs/stats${queryString ? `?${queryString}` : ''}`);
    return response.data;
  }
};

export default odcService;
